// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dQ-z","twoColumnImage":"eQ-z"};